import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

type Props = {};

const ShopBoxEmptyState = (props: Props) => {
  const { t } = useAppTranslation("battle");

  return (
    <div className="dark-yellow text-center">
      {t("shop.empty.title")}
      <br />
      {t("shop.empty.description")}
    </div>
  );
};

export default ShopBoxEmptyState;
